import { RootAction } from 'store/state';
import { SET_MUTATION_RESPONSE } from 'store/state/mutationsResponse/types';
import { LoadType, MutationType } from './apiService/types';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as Types from 'store/state/realEstateOffice/types';
import { updateOfficeAction, updateOfficeStaffMembersAction } from 'store/state/realEstateOffice/actions';
import { mutate, SetMutationResponseAction } from 'store/state/mutationsResponse/actions';
import { navigateTo } from 'store/state/router/actions';
import { Route } from 'config/routes';
import { setToastMessage } from 'store/state/app/actions';
import { resetDomainData } from 'store/state/domainData/actions';
import { queryData } from './apiService';

const updateOfficeMutationPattern = (action: RootAction) => (
  action.type === SET_MUTATION_RESPONSE && action.mutationType === MutationType.UpdateOffice
);

const updateOfficeStaffMembersMutationPattern = (action: RootAction) => (
  action.type === SET_MUTATION_RESPONSE && action.mutationType === MutationType.UpdateOfficeStaffMembers
);

function* updateOfficeWorker(action: ReturnType<typeof updateOfficeAction>) {
  const { payload: { office } } = action;

  yield put(mutate({
    mutationType: MutationType.UpdateOffice,
    meta: {
      variables: {
        office,
      },
    },
  }));
}

function* updateOfficeStaffMembersWorker(action: ReturnType<typeof updateOfficeStaffMembersAction>) {
  const { payload: { officeId, staffMembers } } = action;

  yield put(mutate({
    mutationType: MutationType.UpdateOfficeStaffMembers,
    meta: {
      variables: {
        officeId,
        staffMembers,
      },
    },
  }));
}

function* updateOfficeResponseWorker(action: SetMutationResponseAction<MutationType.UpdateOffice>) {
  if (action.meta.response.data && action.meta.response.data.publicUpdateRealEstateOffice) {
    yield put(navigateTo(Route.OfficeStaffPage));
    yield put(setToastMessage({ term: 'officeProfile.submit.successMessage', type: 'success' }));
  }
  else yield put(setToastMessage({ term: 'officeProfile.submit.errorMessage', type: 'error' }));
}

function* updateOfficeStaffMembersResponseWorker(action: SetMutationResponseAction<MutationType.UpdateOfficeStaffMembers>) {
  if (!action.meta.response.data || !action.meta.response.data.publicUpdateRealEstateOfficeStaffMembers) {
    yield put(setToastMessage({ term: 'officeStaff.membersTable.updateMembers.errorMessage', type: 'error' }));
    const { officeId } = action.meta.variables;
    yield put(resetDomainData({ loadType: LoadType.GetPublicRealEstateOfficeById }));
    yield call(queryData, { loadType: LoadType.GetPublicRealEstateOfficeById, meta: { variables: { officeId } } });
  }
}

export function* realEstateOfficeWatcher() {
  yield takeLatest(Types.UPDATE_OFFICE, updateOfficeWorker);
  yield takeLatest(Types.UPDATE_OFFICE_STAFF_MEMBERS, updateOfficeStaffMembersWorker);
  yield takeLatest(updateOfficeMutationPattern, updateOfficeResponseWorker);
  yield takeLatest(updateOfficeStaffMembersMutationPattern, updateOfficeStaffMembersResponseWorker);
}
